import { IntlProvider } from 'react-intl'
import { CssBaseline } from '@material-ui/core'
import AuthorizedApolloProvider from 'Apollo/Config/AuthorizedApolloProvider'
import { MuiThemeProvider } from '@material-ui/core/styles'
import { StyledEngineProvider } from '@mui/material/styles'
import { BirdsongProvider } from '@resiliatech/birdsong'
import AppBar from 'Components/Views/AppBar/AppBar'
import { useStyles } from 'Components/App/App.styles'
import { AppProvider } from 'Context/AppContext/AppContext'
import { SnackbarProvider } from 'Context/SnackbarContext/SnackbarContext'
import { useCommunityCookie } from 'Hooks/useCommunityCookie'
import { useRouteChange } from 'Hooks/useRouteChange'
import { ErrorBoundaryWithContext } from '../ErrorBoundaryWithContext'
import { baseTheme } from '../../Themes/BaseTheme'
import Analytics from './Analytics'
import AppRoutes from './AppRoutes/AppRoutes'
import { AppNavigationContainer } from './AppNavigation'

const App = () => {
  const classes = useStyles()
  useCommunityCookie()
  useRouteChange()

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppProvider>
        <IntlProvider locale='en'>
          <ErrorBoundaryWithContext>
            <AppBar />
            <SnackbarProvider>
              <AppNavigationContainer>
                <AppRoutes />
              </AppNavigationContainer>
            </SnackbarProvider>
            <Analytics />
          </ErrorBoundaryWithContext>
        </IntlProvider>
      </AppProvider>
    </div>
  )
}

const AppWithProviders = () => (
  <AuthorizedApolloProvider>
    <BirdsongProvider>
      <MuiThemeProvider theme={baseTheme}>
        <StyledEngineProvider>
          <App />
        </StyledEngineProvider>
      </MuiThemeProvider>
    </BirdsongProvider>
  </AuthorizedApolloProvider>
)

export default AppWithProviders
